import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Image, Form } from 'react-bootstrap';

import { noop } from '@ajaibid/utils';
import { Button } from '@ajaibid/components';
import { onDoSubmittedPaymentProof } from 'Redux/mfTransaction';

import { Loader } from 'Component/Loader';
import { Icon } from 'Component/Icon';
import { Text } from 'Component/Ajaib';

import useEventTracker from '../../../tracker';
import { styRowWrapper, styWrapperUploadPayment } from './style';

const ICON_NO_PHOTO = require('Icon/icon_picture_small.png');

const PaymentUpload = (props) => {
  const { onHidePaymentUpload, paymentId, dispatch, onUploaded } = props;

  const [photo, changePhoto] = useState(null);
  const { eventClickUploadPaymentProofConfirm } = useEventTracker();

  const doUpload = (filePath) => {
    changePhoto(filePath);
  };

  function previewImage() {
    const oFReader = new FileReader();
    oFReader.readAsDataURL(document.getElementById('image-source').files[0]);

    oFReader.onload = function (oFREvent) {
      document.getElementById('image-preview').src = oFREvent.target.result;
    };
  }

  return (
    <>
      <Form.Group controlId="formBasicEmail" className={styWrapperUploadPayment}>
        <Form.Control
          className="d-none"
          accept="image/*"
          type="file"
          id="image-source"
          onChange={(file) => {
            doUpload(file.target.files);
            previewImage();
          }}
        />
        <Form.Label
          htmlFor="image-source"
          style={{
            marginBottom: 0,
            alignItems: 'center',
            padding: 30,
            justifyContent: 'space-between',
          }}
          className="text-blue"
        >
          {photo ? (
            <Row className={styRowWrapper}>
              <Image
                style={{ objectFit: 'cover', width: 204, height: 270 }}
                id="image-preview"
                alt=""
              />
            </Row>
          ) : (
            <Row noGutters>
              <Icon src={ICON_NO_PHOTO} size={24} />
            </Row>
          )}
        </Form.Label>
      </Form.Group>
      <Text className="mt-8">Pastikan semua detail bukti transfer terlihat jelas.</Text>
      <Row className="ml-0 mr-0 mt-40">
        <Col className="pl-0">
          <Button
            variant="grey-outlined"
            fluid
            onClick={() => {
              onHidePaymentUpload();
            }}
          >
            Batal
          </Button>
        </Col>
        <Col className="pl-0">
          {onUploaded ? (
            <Loader />
          ) : (
            <Button
              variant="primary"
              fluid
              disabled={!photo}
              onClick={() => {
                const payload = {
                  id: paymentId,
                  proof: photo,
                };
                dispatch(onDoSubmittedPaymentProof(payload));
                eventClickUploadPaymentProofConfirm();
                setTimeout(() => {
                  onHidePaymentUpload();
                }, 1000);
              }}
            >
              Unggah
            </Button>
          )}
        </Col>
      </Row>
    </>
  );
};

PaymentUpload.propTypes = {
  dispatch: PropTypes.func,
  onHidePaymentUpload: PropTypes.func,
  paymentId: PropTypes.string,
  onUploaded: PropTypes.bool,
};

PaymentUpload.defaultProps = {
  dispatch: noop,
  onHidePaymentUpload: noop,
  paymentId: '',
  onUploaded: null,
};

export default PaymentUpload;
